/**
 * @typedef {number} DerbyStatus
 */

const DERBY_STATUS_INCOMING = 1;
const DERBY_STATUS_ACTIVE   = 2;
const DERBY_STATUS_FINISHED = 3;

export class Derby {
  static #statusesNameMap = {
    [DERBY_STATUS_INCOMING]: 'incoming',
    [DERBY_STATUS_ACTIVE]:   'active',
    [DERBY_STATUS_FINISHED]: 'finished',
  };

  static isIncoming(status) {
    return status == DERBY_STATUS_INCOMING;
  }

  static isActive(status) {
    return status == DERBY_STATUS_ACTIVE;
  }

  static isFinished(status) {
    return status == DERBY_STATUS_FINISHED;
  }

  static getStatusName(status) {
    return Derby.#statusesNameMap[status];
  }
}

/**
 * @param {DerbyStatus} status
 * @returns {boolean}
 */
export function isDerbyDeletable(status) {
  return status === DERBY_STATUS_INCOMING || status === DERBY_STATUS_FINISHED;
}

/**
 * @param {DerbyStatus} status
 * @returns {Object}
 */
export function getDerbyStatusClass(status) {
  return {
    'active-derby': Derby.isActive(status),
  };
}

export function createDerbyLocation(derbyId) {
  const location = {
    name: 'derby_info',
    params: {
      derbyId: derbyId,
    },
  };

  return location;
}

//-----------------------------------------------------------------------------

export const DEFAULT_DERBY_AUDIENCE = 0;
export const DERBY_AUDIENCE_ALL = 0;
export const DERBY_AUDIENCE_QA = 1;
export const DERBY_AUDIENCE_EXCEPT_QA    = 2;

/**
 * Options for component b-form-select.
 * @returns {PlayerGroupOption[]}
 */
export function getDerbyAudienceVerbose() {
  const options = [];

  const audiences = [ DERBY_AUDIENCE_ALL, DERBY_AUDIENCE_QA, DERBY_AUDIENCE_EXCEPT_QA];
  for(const audience of audiences) {
    const option = {
      value: audience,
      text: getDerbyAudienceNameVerbose(audience),
    };
    options.push(option);
  }

  return options;
}

export function getDerbyAudienceNameVerbose(audience) {
  switch(audience) {
    case DERBY_AUDIENCE_ALL:       return 'all';
    case DERBY_AUDIENCE_QA:        return 'QA';
    case DERBY_AUDIENCE_EXCEPT_QA: return 'all except QA';
  }
  return `Unknown audience ${audience}.`;
}

/**
 * @typedef {Object} DerbyABTest
 * @property {number} id
 * @property {string} group
 */

//-----------------------------------------------------------------------------

const RACE_STATUS_OPEN     = 1;
const RACE_STATUS_CLOSED   = 2;
const RACE_STATUS_FINISHED = 3;

export class Race {
  static #statusesNameMap = {
    [RACE_STATUS_OPEN]:     'open',
    [RACE_STATUS_CLOSED]:   'closed',
    [RACE_STATUS_FINISHED]: 'finished',
  };

  static isOpen(status) {
    return status == RACE_STATUS_OPEN;
  }

  static isClosed(status) {
    return status == RACE_STATUS_CLOSED;
  }

  static isFinished(status) {
    return status == RACE_STATUS_FINISHED;
  }

  static getStatusName(status) {
    return Race.#statusesNameMap[status];
  }
}

export function getRaceStatusClass(status) {
  return {
    'derby-race-status-open': Race.isOpen(status),
  };
}

//-----------------------------------------------------------------------------

const PARTICIPANT_STATUS_IN_PROGRESS = 0;
const PARTICIPANT_STATUS_FINISHED    = 1;

export class Participant {
  static #statusesNameMap = {
    [PARTICIPANT_STATUS_IN_PROGRESS]: 'not finished',
    [PARTICIPANT_STATUS_FINISHED]:    'finished',
  };

  static inProgress(status) {
    return status == PARTICIPANT_STATUS_IN_PROGRESS;
  }

  static isFinished(status) {
    return status == PARTICIPANT_STATUS_FINISHED;
  }

  static getStatusName(status) {
    return Participant.#statusesNameMap[status];
  }
}
